import { Box } from "@mui/material";
import { type FacilityUser } from "@src/appV2/ExperimentalHomeHealth/lib/types";
import { useIsAdmin } from "@src/appV2/ExperimentalHomeHealth/lib/useIsAdmin";
import { Text } from "@src/lib/ui-react";

import { useGetFacilityUserInternalNotes } from "./api/useGetFacilityUserInternalNotes";

interface FacilityUserInternalNotesTruncatedDisplayProps {
  facilityUser: FacilityUser;
  workplaceId: string;
}

export function FacilityUserInternalNotesTruncatedDisplay(
  props: FacilityUserInternalNotesTruncatedDisplayProps
) {
  const { facilityUser, workplaceId } = props;
  const isAdmin = useIsAdmin();

  const { data, isLoading, isError } = useGetFacilityUserInternalNotes(
    {
      facilityUserId: facilityUser._id,
      workplaceId,
    },
    { enabled: isAdmin }
  );

  if (!isAdmin) {
    return null;
  }

  if (isLoading || isError) {
    return null;
  }

  const notes = data?.data?.attributes?.notes;

  if (!notes || notes.trim() === "") {
    return null;
  }

  const truncatedNotes = notes.length > 50 ? `${notes.slice(0, 50)}...` : notes;

  return (
    <Box
      sx={{
        marginTop: 0.5,
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <Text
        variant="caption"
        color="text.secondary"
        sx={{
          fontStyle: "italic",
          display: "block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
        }}
      >
        {truncatedNotes}
      </Text>
    </Box>
  );
}
